let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("11tIB"), load("kmhnK"), load("joJy8"), load("aHE9G"), load("dXoLf")]).then(() => parcelRequire('gaLJH'));